<template>
  <span class="rounded-md shadow-sm" :class="fullWidth ? 'w-full block' : 'inline-block text-right'">
    <button type="submit"
      class="flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-brandpreneurship-dark-gray focus:outline-none focus:border-black focus:shadow-outline-red active:bg-black transition duration-150 ease-in-out"
      :class="[sending || !validated ? 'opacity-50 cursor-not-allowed' : 'hover:bg-black', fullWidth ? 'w-full' : 'text-right']"
      :disabled="sending || !validated">

      <svg v-if="sending" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
        stroke="currentColor" class="w-5 h-5 mr-2 animate-spin">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
      <slot />
    </button>
  </span>
</template>

<script>
export default {
  props: {
    fullWidth: {
      default: true
    },
    sending: {
      default: false
    },
    validated: {
      default: false
    }
  }
};
</script>
